import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { Filters } from 'src/components/SportPopup/MarketFilters/Filters';
import { AllMarkets } from 'src/components/SportPopup/MarketFilters/AllMarkets';
import DatePicker from 'react-datepicker';
import { ColumnsWrapper, DatePickerWrapper } from 'src/components/SportPopup/MarketFilters/MarketFilters.style';
import { action, observable, makeAutoObservable } from 'mobx';
import { MarketFiltersState } from 'src/AppState/MarketFiltersState/MarketFiltersState';
import { MarketsForFilter } from './MarketsForFilter';
import { DateInputWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';
import { InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

export class FiltersState {
    @observable public startDate: Date = new Date();
    @observable public endDate: Date = new Date();

    public constructor(readonly marketFiltersState: MarketFiltersState) {
        this.startDate = marketFiltersState.eventsFromDate;
        this.endDate = marketFiltersState.eventsEndDate;
        makeAutoObservable(this);
    }

    @action setStartDate = (date: Date | null): void => {
        if (date !== null) {
            this.startDate = date;
        }
        this.updatePeriodForEvents();
    };

    @action setEndDate = (date: Date | null): void => {
        if (date !== null) {
            this.endDate = date;
        }
        this.updatePeriodForEvents();
    };

    @action updatePeriodForEvents = (): void => {
        this.marketFiltersState.setEventsFromDate(this.startDate);
        this.marketFiltersState.setEventsEndDate(this.endDate);
    };
}
interface PropsTypes {
    sportId: string;
    label: string; //TODO - to be removed
}

export const MarketFilters = observer(({ sportId }: PropsTypes) => {
    const { marketFiltersState } = useAppStateContext();
    const marketStateBySport = marketFiltersState.get(sportId);
    const [state] = useState(() => new FiltersState(marketStateBySport));

    return (
        <>
            <DatePickerWrapper>
                <DateInputWrapper>
                    <InputLabel>From</InputLabel>
                    <DatePicker
                        selected={state.startDate}
                        onChange={state.setStartDate}
                        onBlur={state.updatePeriodForEvents}
                        showTimeSelect
                        timeFormat='HH:mm'
                        timeIntervals={30}
                        timeCaption='time'
                        dateFormat='dd/MM/yyyy HH:mm:ss'
                    />
                </DateInputWrapper>
                <DateInputWrapper>
                    <InputLabel>To</InputLabel>
                    <DatePicker
                        selected={state.endDate}
                        onChange={state.setEndDate}
                        onBlur={state.updatePeriodForEvents}
                        showTimeSelect
                        timeFormat='HH:mm'
                        timeIntervals={30}
                        timeCaption='time'
                        dateFormat='dd/MM/yyyy HH:mm:ss'
                    />
                </DateInputWrapper>
            </DatePickerWrapper>

            <ColumnsWrapper>
                <Filters sportName={sportId} />
                {marketStateBySport.selectedFilter !== null ? <MarketsForFilter sportName={sportId} /> : null}
                <AllMarkets sportName={sportId} />
            </ColumnsWrapper>
        </>
    );
});
